/**
 * 设备模块API
 */
import { GET, POST,EXPORT,DELETE } from '@/request/http'

/**
 * 获取设备运行模式
 */
export const getEquipmentWorkmode = p => POST('/equipment/workmode/list', p, 1)
/**
 * 新增设备运行模式
 */
export const addEquipmentWorkmode = p => POST('/equipment/workmode/save', p, 1)
/**
 * 编辑设备运行模式
 */
export const editEquipmentWorkmode = p => POST('/equipment/workmode/update', p, 1)
/**
 * 设备运行分页查询
 */
export const getEqWorkFlowTable = p => POST('/equipment/workflow/page', p)
/**
 * 查询设备
 */
export const getEquipmentTable = p => POST('/equipment/page', p, 1)

/**
 * 查询品牌列表
 */
export const getBrandList = p => POST('/equipment/brand/list', p, 1)
/**
 * 新增品牌
 */
export const addBrand = p => POST('/equipment/brand/save', p, 1)
/**
 * 编辑品牌
 */
export const editBrand = p => POST('/equipment/brand/update', p, 1)

/**
 * 查询型号列表
 */
export const getModelList = p => POST('/equipment/model/list', p, 1)
/**
 * 新增型号
 */
export const addModel = p => POST('/equipment/model/save', p, 1)
/**
 * 编辑型号
 */
export const editModel = p => POST('/equipment/model/update', p, 1)
/**
 * 根据型号id查询已绑定运行模式
 */
export const getWorkModeByModelId = p => POST('/equipment/model/workmode/list', p, 1)
/**
 * 更新绑定运行模式
 */
export const updateWorkMode = p => POST('/equipment/model/workmode/update', p, 1)

/**
 * 更新绑定运行模式
 */
export const getEquipmentReport = p => POST('/equipment/workorder/daliyreport/orgreport/get/bycurrentuserorg', p, 1)

/**
 * 获取设备订单
 */
export const getEquipmentOrder = p => POST('/equipment/workorder/page', p, 1)

/**
 * 返券
 */
export const returnCoupon = p => POST('/equipment/workorder/returncoupon', p, 1)

//查询返券
export const couponlistliterature = p => POST('/member/coupon/page', p)
/**
 * 更新用户的设备管理权限
 */
export const updateEqManagepermission = p => POST('/equipment/managepermission/user/location/update', p, 1)
/**
 * 查询当前用户能管理的位置树
 */
export const eqGetUserlocationtree = p => POST('/equipment/managepermission/user/location/locationtree/list/bycurrentuser', p, 1)
/**
 * 根据用户查询绑定的位置
 */
export const eqGetBindLocationByUse = p => POST('/equipment/managepermission/user/location/singlelevellocationid/list/byuserid', p, 1)
/**
 * 根据条件,查询分组的收入、退款等信息
 */
export const getEquipmentWorkOrderReport = p => POST('/equipment/workorder/getreport', p, 1)
/**
 * 根据条件,导出分组的收入、退款等信息
 */
export const getEquipmentWorkOrderReportExport = p => EXPORT('/equipment/workorder/getreport/export', p, 1)
/**
 * 分页查询评论列表
 */
export const getOrderEvaluationList = p => GET('/equipment/evaluate/getlist', p, 1)
/**
 * 根据设备id查询维护记录列表
 */
export const getEquipmentMaintenanceRecords = p => GET('/equipment/maintflow/page', p, 1)
/**
 * 根据id删除优惠券
 */
export const deleteMemberCoupon = p => DELETE('/member/coupon/delete/{id}', p, 1)
/**
 * 根据userid查询用户权限信息list
 */
export const getManagePermissionByUserId = p => GET('/equipment/managepermission/user/location/list/byuserid', p, 1)
/**
 * 通过主键id是否开启短信接收
 */
export const updateManagePermissionById = p => POST('/equipment/managepermission/user/location/update/receive', p, 1)



// WEBPACK FOOTER //
// ./src/api/modules/equipment.js